import React from 'react'

import Resume from './resume'

const IndexPage: React.FC = () => <Resume />

export default IndexPage
